"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Loader: function() {
        return Loader;
    },
    StickyHeaderTable: function() {
        return StickyHeaderTable;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _localisationeq1 = require("@equiem/localisation-eq1");
const _ProgressCircle = require("../ProgressCircle/ProgressCircle");
const _StickyElement = require("../Sticky/StickyElement");
const _Table = require("./Table");
const _Header = require("./Header");
const _TablePagination = require("./TablePagination");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const Loader = (param)=>{
    let { loading, colSpan } = param;
    const { t } = (0, _localisationeq1.useTranslation)();
    if (!loading) {
        return null;
    }
    return /*#__PURE__*/ _react.default.createElement("tr", null, /*#__PURE__*/ _react.default.createElement("td", {
        colSpan: colSpan
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: "mt-6 mb-6 d-flex justify-content-center align-items-center"
    }, /*#__PURE__*/ _react.default.createElement(_ProgressCircle.ProgressCircle, {
        size: "md"
    }), /*#__PURE__*/ _react.default.createElement("span", {
        className: "ml-4"
    }, "".concat(t("common.loading"), "...")))));
};
const StickyHeaderTable = (param)=>{
    let { rowHeaders, overlayHeader, loading, children, sort, pagination, responsive, responsiveWidth } = param;
    return /*#__PURE__*/ _react.default.createElement(_StickyElement.StickyElement, null, (param)=>{
        let { ref, top, isStuck } = param;
        return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(_Table.Table, {
            className: "w-100",
            sticky: {
                top,
                isStuck
            },
            responsive: responsive,
            responsiveWidth: responsiveWidth
        }, /*#__PURE__*/ _react.default.createElement("thead", {
            className: "jsx-952ed9572562c3eb"
        }, /*#__PURE__*/ _react.default.createElement("tr", {
            className: "jsx-952ed9572562c3eb"
        }, rowHeaders.map((label, i)=>/*#__PURE__*/ _react.default.createElement(_Header.Header, {
                key: i,
                ref: i === 0 ? ref : null,
                label: label,
                direction: (sort === null || sort === void 0 ? void 0 : sort.columnIndex) === i ? sort.direction : undefined,
                onClick: ()=>sort === null || sort === void 0 ? void 0 : sort.handleSort(i)
            })), overlayHeader != null && /*#__PURE__*/ _react.default.createElement("div", {
            className: "jsx-952ed9572562c3eb" + " " + "overlay"
        }, overlayHeader))), /*#__PURE__*/ _react.default.createElement("tbody", {
            className: "jsx-952ed9572562c3eb"
        }, children, loading && /*#__PURE__*/ _react.default.createElement(Loader, {
            loading: loading,
            colSpan: rowHeaders.length
        }))), pagination != null && /*#__PURE__*/ _react.default.createElement(_TablePagination.TablePagination, pagination), /*#__PURE__*/ _react.default.createElement(_style.default, {
            id: "952ed9572562c3eb"
        }, "thead.jsx-952ed9572562c3eb{position:relative}.overlay.jsx-952ed9572562c3eb{position:absolute;top:0;left:0;right:0;z-index:1;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background:white;-webkit-border-top-right-radius:8px;-moz-border-radius-topright:8px;border-top-right-radius:8px;-webkit-border-top-left-radius:8px;-moz-border-radius-topleft:8px;border-top-left-radius:8px}"));
    });
};

//# sourceMappingURL=StickyHeaderTable.js.map